function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.4667 7.78283C16.2867 9.60283 16.2867 12.5557 14.4667 14.3768C12.6443 16.1968 9.6915 16.1968 7.87033 14.3768C6.111 12.6163 6.0515 9.79883 7.69533 7.96833L7.87033 7.78283C9.69033 5.96049 12.6443 5.96049 14.4667 7.78283ZM9.191 9.10233C8.099 10.1943 8.099 11.9653 9.191 13.0573C10.283 14.1493 12.054 14.1493 13.146 13.0573C14.238 11.9653 14.238 10.1943 13.146 9.10233C12.103 8.05933 10.4417 8.01149 9.34383 8.95999L9.191 9.10233Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.5968 4.64684C14.0455 1.0955 8.28917 1.0955 4.73783 4.64684C1.1865 8.19817 1.1865 13.9557 4.73783 17.5058C7.38617 20.1542 11.2595 20.8273 14.532 19.5265L20.111 25.1067C21.5157 26.5113 23.793 26.5113 25.1965 25.1067C26.5463 23.7568 26.5988 21.6008 25.3517 20.188L25.1965 20.0223L22.1095 16.9353C21.6545 16.4803 20.9148 16.4803 20.4598 16.9353C20.0398 17.3553 20.006 18.018 20.3618 18.4753L20.4598 18.585L23.5457 21.672C24.0392 22.1655 24.0392 22.9635 23.5457 23.457C23.0883 23.9143 22.3673 23.947 21.8715 23.555L21.7618 23.457L16.6425 18.3388C16.975 18.088 17.2935 17.8103 17.5968 17.507C21.1482 13.9568 21.1482 8.19934 17.5968 4.648V4.64684ZM6.60567 6.08884C9.2575 3.65867 13.3782 3.7275 15.9472 6.2965C18.5862 8.93667 18.5862 13.216 15.9472 15.8562C13.307 18.4963 9.02883 18.4963 6.3875 15.8562C3.7485 13.216 3.7485 8.93667 6.3875 6.2965L6.60567 6.08884Z",
  fill: "currentColor"
});

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.795b380f.svg";
export { ForwardRef as ReactComponent };